export const CatalogueMasterConstants = {

  GETALL_REQUEST: "CATALOGUE_GETALL_REQUEST",
  GETALL_SUCCESS: "CATALOGUE_GETALL_SUCCESS",
  GETALL_FAILURE: "CATALOGUE_GETALL_FAILURE",

  UPSERT_HEADER_REQUEST: "CATALOGUE_UPSERT_HEADER_REQUEST",
  UPSERT_HEADER_SUCCESS: "CATALOGUE_UPSERT_HEADER_SUCCESS",
  UPSERT_HEADER_FAILURE: "CATALOGUE_UPSERT_HEADER_FAILURE",

  UPSERT_DETAILS_REQUEST: "CATALOGUE_UPSERT_DETAILS_REQUEST",
  UPSERT_DETAILS_SUCCESS: "CATALOGUE_UPSERT_DETAILS_SUCCESS",
  UPSERT_DETAILS_FAILURE: "CATALOGUE_UPSERT_DETAILS_FAILURE",

  LOADING_REQUEST: "CATALOGUE_LOADING_REQUEST",
};

